import PropTypes from 'prop-types';
import ProductCard from './ProductCard';
import Loading from '../common/Loading';
import Alert from '../common/Alert';
import './ProductList.css';

const ProductList = ({
  products = [],
  loading = false,
  error = null,
  compact = false,
}) => {
  if (loading && products.length === 0) {
    return (
      <div className="product-list__state">
        <Loading />
        <p className="product-list__state-text">Loading products…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="product-list__state">
        <Alert type="error">
          {error.message || 'Failed to load products. Please try again.'}
        </Alert>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="product-list__empty">
        <p className="product-list__empty-label">No Products Available</p>
        <p className="product-list__empty-sub">Please check back later.</p>
      </div>
    );
  }

  return (
    <div className="product-list">
      <div className={`product-list__grid ${compact ? 'product-list__grid--compact' : ''}`}>
        {products.map((product, index) => (
          <ProductCard
            key={product.id}
            product={product}
            compact={compact}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

ProductList.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      image_url: PropTypes.string,
      variants: PropTypes.array,
    })
  ),
  loading: PropTypes.bool,
  error: PropTypes.object,
  compact: PropTypes.bool,
};

export default ProductList;
